export default {"src":"/_next/static/media/civicsBg.e7c6218b.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};